import React from "react"

import {
	DataGrid,
	GridColDef,
} from "@mui/x-data-grid"

import {
	OrderType,
	PaginatedResponse,
	SearchFilter,
} from "models"

import getTableColumns, {FavouriteAssetColumnInterface} from "./table-columns"
import {SbPaginatedDatagrid} from "../../commons";
import {FavouriteResponse} from "../../../models/favourite";
import {ErrorResponse, RestResponse} from "@sinossi/mates-react-library";
import {MatesComponent, MatesComponentState} from "../../mates-component";
import withUseRouter, {UseRouterParams} from "../../../services/router";

interface FavouriteAssetsTableProps extends UseRouterParams
{
	getFavourite: (request?: SearchFilter) => void
	data: PaginatedResponse<FavouriteResponse> | null
}
interface FavouriteAssetsTableState extends MatesComponentState
{
	data: PaginatedResponse<FavouriteResponse> | null
	pagination: SearchFilter
}

class FavouriteAssetsTable extends React.Component<FavouriteAssetsTableProps, FavouriteAssetsTableState>
	implements FavouriteAssetColumnInterface
{
	private readonly columns: GridColDef[]
	private readonly matesComponent: MatesComponent<FavouriteAssetsTableProps, FavouriteAssetsTableState> = new MatesComponent(this)

	constructor(props: FavouriteAssetsTableProps)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			data: this.props.data,
			pagination: new SearchFilter()
		}
		this.columns = getTableColumns(this)
	}

	componentDidUpdate(prevProps: Readonly<FavouriteAssetsTableProps>, prevState: Readonly<FavouriteAssetsTableState>, snapshot?: any) {
		if(prevProps.data !== this.props.data){
			this.setState(() => ({
				data: this.props.data
			}))
		}
	}

	public removeCallback = (response: RestResponse<any, ErrorResponse>) => {
		if(response.hasError()) {
			this.matesComponent.onException(response)
			return
		}

		this.props.getFavourite()
	}

	public onError = (response: any) => {
		this.matesComponent.onError(response)
	}

	private onPaginationChanged = (pageId: number, pageSize: number): void => {
		let newPageId: number = this.state.pagination.pageId
		let newPageSize: number = this.state.pagination.pageSize
		if(this.state.pagination.pageId !== pageId){
			newPageId = pageId
		}
		if(this.state.pagination.pageSize !== pageSize){
			newPageSize = pageSize
			newPageId = 0
		}
		this.setState(
			() => ({
				pagination: {
					...this.state.pagination,
					pageId: newPageId,
					pageSize: newPageSize
				},
			}),
			() => this.props.getFavourite(this.state.pagination)
		)
	}

	private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
		if(this.state.pagination.orderBy !== orderBy || this.state.pagination.orderType !== orderType){
			this.setState(
				() => ({
					pagination: {
						...this.state.pagination,
						orderBy: orderBy,
						orderType: orderType,
					},
				}),
				() => this.props.getFavourite(this.state.pagination)
			)
		}
	}

	render()
	{
		return (
				<SbPaginatedDatagrid columns={this.columns}
									 data={this.state.data}
									 pagination={this.state.pagination}
									 onPaginationChanged={this.onPaginationChanged}
									 onSortChanged={this.onSortChanged}
									 initialSorting={[]}
				/>
		)
	}
}

export default withUseRouter(FavouriteAssetsTable)
